import { Snackbar, Alert, Button } from '@mui/material'
import { Refresh } from '@mui/icons-material'
import { useVersionCheck } from '@hooks/useVersionCheck'

/**
 * Bottom snackbar shown when a newer version has been deployed while the tab was
 * open. Nudges the user to reload (which pulls the fresh index.html now that it's
 * served no-cache) instead of eventually hitting a stale-chunk fetch error.
 */
export function UpdateAvailableSnackbar() {
  const updateAvailable = useVersionCheck()

  return (
    <Snackbar
      open={updateAvailable}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        variant="filled"
        icon={<Refresh />}
        sx={{ alignItems: 'center' }}
        action={
          <Button color="inherit" size="small" onClick={() => window.location.reload()}>
            Reload
          </Button>
        }
      >
        A new version is available.
      </Alert>
    </Snackbar>
  )
}
